module.exports = __webpack_public_path__ + "static/media/haven.4397e5b8.png";